import { useState, useEffect } from "react";

const phrases = [
  "Hypno-Psychedelics",
  "Sesiones secretas",
  "Libros exclusivos",
  "Material privado",
  "Eventos en vivo",
];

export default function ExtraAccess() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % phrases.length), 2400);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      id="testimonios"
      data-testid="extra-access-section"
      className="relative py-20 lg:py-28 bg-[#030303] border-t border-[#B49A6C]/10 overflow-hidden"
    >
      <div className="absolute inset-0 pattern-hypnotic-radial" />
      <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-[700px] h-[700px] pattern-rings opacity-30 spin-slow rounded-full" />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-12">
        <p className="text-[10px] uppercase tracking-[0.45em] text-[#B49A6C] mb-12 flex items-center gap-4">
          <span className="h-px w-12 bg-[#B49A6C]/50" />
          Más allá de los programas
        </p>

        <h2 className="font-display font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.25] tracking-tight text-[#E8E5DC]">
          Dentro de la plataforma también podrás encontrar accesos extra a{" "}
          <span className="italic text-metal">libros</span> y a sesiones
          especiales como{" "}
          <span
            data-testid="rotating-word"
            key={idx}
            className="inline-block italic text-metal animate-[fadeUp_0.8s_ease-out]"
          >
            {phrases[idx]}
          </span>
          .
        </h2>

        <div className="divider-metal my-14" />

        <p className="font-display font-light text-xl sm:text-2xl lg:text-3xl leading-[1.4] tracking-tight text-[#A89F8E]">
          Una vez dentro de la plataforma te enterarás de todo en{" "}
          <span className="text-[#E8E5DC]">tiempo real</span> con notificaciones
          directo en tu app.
        </p>
      </div>

      <style>{`
        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(8px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
